var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-btn',{attrs:{"to":{
    name: 'Documentation',
    params: {
      category: 'introduction',
      page: 'why-vuetify'
    }
  },"path":"guide"}})}
var staticRenderFns = []

export { render, staticRenderFns }